import { UserApi } from "@/api/user.api";

export default async function profileDetailsLoader() {
  const [user] = await Promise.all([UserApi.getUser()]);

  return {
    user: user.data.user,
  };
}
